<div class="gallery-wrapper">
  <swiper-container events-prefix="swiper-" #gallerySlider initial-slide="{{ initialGallerySlide }}"
    class="main-gallery">
    @if(images?.length > 0){
    @for (image of images; track image.id; let index = $index) {
    <swiper-slide>
      <app-product-image-wrapper [showImageExplanation]="showImageExplanation" [images]="images" [index]="index">
        <img [src]="image | assetPreview : 405" [alt]="image.name" />
      </app-product-image-wrapper>
    </swiper-slide>
    }
    } @else {
    <swiper-slide>
      <app-product-image-wrapper>
        <div class="img-wrapper">
          <img src="./.../../../../../../assets/images/placeholders/no-img-placeholder.svg" [alt]="'no-image'">
        </div>
      </app-product-image-wrapper>
    </swiper-slide>

    }
  </swiper-container>

  @if (swiperThumbnails) {
  <swiper-container direction="{{ thumbnailsSwiperDirection }}" events-prefix="swiper-thumbnails-"
    initial-slide="{{ initialGallerySlide }}" #thumbnailsSlider initial-slide="{{ initialGallerySlide }}"
    slides-per-view="4" space-between="8" class="thumbnails-slider">
    @for (image of images; track image.id; let index = $index) {
    <swiper-slide [class.active]="gallerySlider?.swiper?.activeIndex == index"
      (click)="changeActiveGallerySlide(index)">
      <app-product-image-wrapper>
        <img [src]="image | assetPreview : 'thumb'" [alt]="image.name" />
      </app-product-image-wrapper>
    </swiper-slide>
    }
  </swiper-container>
  } @if (gridThumbnails) {
  <div class="grid-thumbnails">
    @for (image of images; track image.id; let index = $index) {
    <div class="img-wrapper" [class.active]="gallerySlider?.swiper?.activeIndex == index"
      (click)="changeActiveGallerySlide(index)">
      <img [src]="image | assetPreview : 'thumb'" alt="" />
    </div>
    }
  </div>
  }
</div>
